module.exports = __webpack_public_path__ + "static/jonatan-c7b8e2b48c40e4af50e86886b22414f6.jpg";